// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dj-2";
export var aiChatCartContainerExit = "_dj-4";
export var aiChatContainerLarge = "_dj-0";
export var aiChatContainerSmall = "_dj-1";
export var aiChatIcon = "_dj-6";
export var slideInFromRight = "_dj-3";
export var slideOutToRight = "_dj-5";